import { useMutation } from 'react-query'

// Services
import { RotateIntegrationToken } from 'services/api/Auth'

export default () => {
  const {
    mutate: rotateIntegrationToken,
    data: rotateIntegrationTokenData,
    error: rotateIntegrationTokenError,
    isLoading: isRotateIntegrationTokenLoading,
    isSuccess: isRotateIntegrationTokenSuccess,
    isError: isRotateIntegrationTokenError,
  } = useMutation(RotateIntegrationToken)

  // credentials and isloggedin are set in the loginform component

  return {
    rotateIntegrationToken,
    rotateIntegrationTokenData,
    rotateIntegrationTokenError,
    isRotateIntegrationTokenLoading,
    isRotateIntegrationTokenSuccess,
    isRotateIntegrationTokenError,
  }
}
